module.exports = __webpack_public_path__ + "static/img/yfzwzwrj.cabc381.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/welcome/yfzwzwrj.png
// module id = ELOc
// module chunks = 1